import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isPutCompaniesCompanyIdOauthMcpSettingsMcpEnabledResult = objectOf({
  mcp_server_enabled: boolean,
});
